import api from "./api";

// Update dos campos do site público de um Roteiro, isolado do update regular
// (que é feito via RoteiroFormModal). Endpoint: PATCH /api/Roteiros/{id}/site.

export async function updateRoteiroSite(id, payload) {
  await api.patch(`/Roteiros/${id}/site`, payload);
}
